import { gql } from "@apollo/client";

export const groupDetailsFragment = gql`
    fragment GroupDetails on GroupWithConnections {
        group {
            name
            id
            description
            status
            totalNumLenses
            readOnly
            updatedAt {
                seconds
            }
        }
        connections {
            connectionId
            lens {
                iconUrl
                name
                updatedAt {
                    seconds
                }
                lensStatus
                removed
                labels {
                    key
                    value
                }
                minSdkVersion
                minWebSdkVersion
                lensSourceInfo {
                    name
                }
                compoundId {
                    id
                    reference
                    lensSourceType
                }
            }
            priority
            vendorData {
                key
                value
            }
            schedule {
                scheduleEnd {
                    seconds
                }
                scheduleStart {
                    seconds
                }
                useClientTimezone
            }
        }
    }
`;
